interface TradeRowWithEventId {
  readonly eventId?: string | null;
}

/** Keep the chart tape scoped to unique events delivered after this detail session began. */
export function selectActiveTradeRows<T extends TradeRowWithEventId>(
  rows: ReadonlyArray<T>,
  liveIds: ReadonlySet<string>,
): T[] {
  const activeRows: T[] = [];
  const seenIds = new Set<string>();

  for (const row of rows) {
    const eventId = row.eventId;
    if (typeof eventId !== 'string' || !liveIds.has(eventId) || seenIds.has(eventId)) continue;
    seenIds.add(eventId);
    activeRows.push(row);
  }

  return activeRows;
}
